import React from 'react';
import SVGFactory, { SVGName } from './svgFactory';
import './GameRules.css'
const GameRules: React.FC<{ onCloseHandle: (flag: boolean) => void }> = ({ onCloseHandle }) => {
    return (
        <div className='bik-modalBackground'>
            <div className='bik-modalOverlay'></div>
            <div className='bik-gameRules'>
                <div onClick={() => onCloseHandle(false)}>
                    <SVGFactory name={SVGName.CROSS} />
                </div>
                <p>Terms and conditions</p>
                <ul>
                    <li><sup>*</sup>The offer can only be redeemed once</li>
                    <li><sup>*</sup>The validity date is April 30th, 2023.</li>
                    <li><sup>*</sup>The redemption is limited to online orders only</li>
                    <li><sup>*</sup>Applicable only to prepaid orders</li>
                    <li><sup>*</sup>Applicable only on the Shoppers Stop website, mobile site, or App.</li>

                </ul>
            </div>
        </div>
    )
}
export default GameRules